import { render, staticRenderFns } from "./InsightTransactionsModal.vue?vue&type=template&id=f0a26628&"
import script from "./InsightTransactionsModal.vue?vue&type=script&lang=js&"
export * from "./InsightTransactionsModal.vue?vue&type=script&lang=js&"
import style0 from "./InsightTransactionsModal.vue?vue&type=style&index=0&id=f0a26628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports